import { ref, onMounted, onUnmounted } from "vue";

/**
 * Returns a reactive limit that's a multiple of the current grid column count.
 * Grid columns: 2 (mobile), 3 (md), 4 (lg), 5 (xl)
 * With the default two rows, returns 4, 6, 8, and 10 respectively.
 */
export function useResponsiveLimit(rowsPerPage = 2) {
  function calculateLimit() {
    if (typeof window === "undefined") return 4 * rowsPerPage;

    const width = window.innerWidth;
    let cols = 2; // mobile default

    if (width >= 1280)
      cols = 5; // xl
    else if (width >= 1024)
      cols = 4; // lg
    else if (width >= 768)
      cols = 3; // md
    else cols = 2; // sm

    return cols * rowsPerPage;
  }

  const limit = ref(calculateLimit()); // Initialize with current screen size

  function updateLimit() {
    limit.value = calculateLimit();
  }

  if (import.meta.client) {
    onMounted(() => {
      updateLimit(); // Recalculate after mount (in case window size changed)
      window.addEventListener("resize", updateLimit);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", updateLimit);
    });
  }

  return limit;
}
